import { dataFetcher } from 'core/services/requestHandler';   
import { format } from 'date-fns';

export const getUserDetailsByMobile = (data = {}, config = {}) => {
  return dataFetcher('user/getUserSuggestionsByMobile', data, {...config});
};

export const getLibraries = async (data = {}, config = {}) => {
  return dataFetcher('libraries/getLibraries', data, { ...config});
};

export const defaultTimeSlots = [
  {time: 0, label: '12:00 AM'}, {time: 1, label: '01:00 PM'}, {time: 2, label: '02:00 AM'}, {time: 3, label: '03:00 AM'},
  {time: 4, label: '04:00 AM'}, {time: 5, label: '05:00 AM'}, {time: 6, label: '06:00 AM'}, {time: 7, label: '07:00 AM'},
  {time: 8, label: '08:00 AM'}, {time: 9, label: '09:00 AM'}, {time: 10, label: '10:00 AM'}, {time: 11, label: '11:00 AM'},
  {time: 12, label: '12:00 PM'}, {time: 13, label: '01:00 PM'}, {time: 14, label: '02:00 PM'}, {time: 15, label: '03:00 PM'},
  {time: 16, label: '04:00 PM'}, {time: 17, label: '05:00 PM'}, {time: 18, label: '06:00 PM'}, {time: 19, label: '07:00 PM'},
  {time: 20, label: '08:00 PM'}, {time: 21, label: '09:00 PM'}, {time: 22, label: '10:00 PM'},{time: 23, label: '11:00 PM'}
];

export function getDBDateFormat(date) {
  return date ? format(date, 'dd-MM-yyyy') : date;
}
